var ajaxActive = false;
let currentCart = { contents: [], total: 0 }; // Initialize for safety
let currentCartValue = 0;
let initialLoad = true;
let lastCartSnapshot = {};
let itemPendingRemoval = null; // Variable to temporarily hold item data for removal event

(function ($) {
  $(document).ready(function () {
    fetchCartData();

    // --- Event Listeners ---

    $(document).on("cartDataLoaded", function (event) {
      // Use the detail property which should contain the cart data object
      if (event.detail) {
        initialLoad = true; // Set flag before the first update
        updateCart(event.detail);
        // Snapshot is taken *after* the initial update
        lastCartSnapshot = getSnapshot(event.detail.contents || []);
        initialLoad = false; // Reset flag after the first update
      } else {
        console.error("cartDataLoaded event fired without detail payload.");
        // Handle empty cart state?
        updateCart({ contents: [], total: 0 }); // Update UI to empty state
        lastCartSnapshot = {};
        initialLoad = false;
      }
    });

    // Listen for custom event when an item is added externally (if applicable)
    $(document).on("addToCartEvent", function (event, response) {
      try {
        // Assuming 'response' might be a JSON string OR an object
        const cartData = typeof response === 'string' ? JSON.parse(response) : response;
        if (cartData) {
          updateCart(cartData);
        } else {
           console.error("addToCartEvent received invalid response:", response);
        }
      } catch (e) {
        console.error("Error parsing addToCartEvent response:", e, response);
      }
    });

    // View Cart Event - Triggered when opening the cart view
    $("[data-hs-overlay='#offcanvas-cart']").on("click touchstart", function () {
      // Ensure cart data is available before pushing
      if (currentCart && currentCart.contents) {
        pushViewCartEvent();
      } else {
        console.warn("Attempted to view cart before cart data was loaded.");
        // Optionally fetch cart data again here if needed
      }
    });

    // Debounced function for quantity updates
    const debouncedUpdateQuantity = debounce(updateQuantity, 350); // Slightly increased debounce time

    // Quantity Increase Button
    $(document).on("click", ".q-inc", function (e) {
      if (ajaxActive) return;
      e.preventDefault();
      const $item = $(e.currentTarget).closest("li[data-key]");
      const $qty = $item.find(".quantity");
      const currentValue = parseInt($qty.val(), 10) || 0;
      const newValue = currentValue + 1;
      const itemKey = $item.data("key");

      // Update UI immediately for responsiveness
      $qty.val(newValue);
      // Store previous value *before* triggering update
      $qty.attr("data-previous-value", currentValue);
      showLoading();

      // Trigger debounced server update
      debouncedUpdateQuantity(itemKey, newValue);
    });

    // Quantity Decrease Button
    $(document).on("click", ".q-dec", function (e) {
      if (ajaxActive) return;
      e.preventDefault();
      const $item = $(e.currentTarget).closest("li[data-key]");
      const $qty = $item.find(".quantity");
      const currentValue = parseInt($qty.val(), 10) || 0;
      // Prevent going below 1 (or 0 if removal is desired)
      const newValue = Math.max(1, currentValue - 1);
      const itemKey = $item.data("key");

      // Only proceed if the value actually changes
      if (newValue !== currentValue) {
        // Update UI immediately
        $qty.val(newValue);
        $qty.attr("data-previous-value", currentValue);
        showLoading();
        // Trigger debounced server update
        debouncedUpdateQuantity(itemKey, newValue);
      }
    });

    // Quantity Manual Change (Input field)
    $(document).on("change", ".quantity", function (e) {
      if (ajaxActive) return;
      const $input = $(e.currentTarget);
      let newValue = parseInt($input.val(), 10);
      const prevValue = parseInt($input.attr("data-previous-value"), 10) || 0;
      const itemKey = $input.closest("[data-key]").data("key");

      // Validate input - ensure it's a number and >= 1
      if (isNaN(newValue) || newValue < 1) {
          newValue = 1; // Reset to 1 if invalid input
          $input.val(newValue);
      }

      // Only trigger update if the value has changed
      if (newValue !== prevValue) {
        $input.attr("data-previous-value", newValue); // Update the stored previous value
        showLoading();
        debouncedUpdateQuantity(itemKey, newValue);
      }
    });

    // Item Remove Button - *** GTM Logic Moved to ajaxRequest success ***
    $(document).on("click", ".item-remove", function (e) {
      if (ajaxActive) return;
      e.preventDefault();
      const $item = $(e.currentTarget).closest("[data-key]");
      const itemKey = $item.data("key");

      // Find the item data from the *current* cart state before removing it
      const itemToRemove = currentCart.contents.find(item => item.key === itemKey);

      if (itemToRemove) {
        // Format the item for GTM *now* while we have the data
        // Use the quantity currently in the cart state
        itemPendingRemoval = transformItemForGTM(itemToRemove);
        // Start the removal process
        showLoading(); // Show loading indicator
        removeItem(itemKey); // Trigger AJAX request
      } else {
        console.error("Could not find item data for key:", itemKey, "in currentCart:", currentCart);
        // Optionally remove the item from UI anyway or show an error
         $item.remove(); // Basic fallback UI removal
         toggleCartState(); // Update empty/full cart view
      }
    });
  }); // end document.ready

  // --- Helper Functions ---

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  function showLoading() {
    // Avoid adding multiple spinners
    if ($(".loading-icon").length === 0) {
      $(".offer-number") // Target the element to show loading state
        .css("opacity", "0.5")
        .before(
          '<span class="loading-icon animate-spin inline-block size-3.5 border-[3px] border-current border-t-transparent text-brand-500 rounded-full shadow-sm me-2" role="status" aria-label="loading"><span class="sr-only">Loading...</span></span>'
        );
    }
  }

  function hideLoading() {
    $(".offer-number").css("opacity", "1");
    $(".loading-icon").remove();
  }

  // Formats an array of cart items for GTM (e.g., for view_cart)
  function formatGTMData(items) {
    if (!Array.isArray(items)) {
        console.error("formatGTMData received non-array:", items);
        return [];
    }
    return items.map((item) => ({
      item_id: item.sku || item.key, // Prefer SKU if available
      item_name: item.name || "Unknown Item",
      // Ensure price is a number, default to 0 if invalid
      price: parseFloat(item.offer) || 0,
      // Ensure quantity is an integer, default to 1 if invalid
      quantity: parseInt(item.quantity, 10) || 1,
      item_brand: item.brand || "", // Provide defaults
      item_category: item.category || "",
      item_category2: item.subcategory || "",
      // Add other relevant GTM parameters like index, variant, etc. if available
    }));
  }

  // Transforms a single cart item into the GTM item format
  // Used for add_to_cart, remove_from_cart events
   function transformItemForGTM(item, quantityOverride = null) {
    const quantity = quantityOverride !== null ? parseInt(quantityOverride, 10) : parseInt(item.quantity, 10);
    const price = parseFloat(item.offer) || 0;

    // Validate quantity
    const finalQuantity = isNaN(quantity) || quantity < 0 ? 1 : quantity;

    return {
      item_id: item.sku || item.key,
      item_name: item.name || "Unknown Item",
      price: price, // GTM usually expects numbers for price/value
      quantity: finalQuantity,
      item_brand: item.brand || "",
      item_category: item.category || "",
      item_category2: item.subcategory || "",
      // The 'value' parameter is usually calculated at the event level (price * quantity)
      // It's generally not needed *inside* the item object itself for standard GA4 events
      // value: price * finalQuantity // Remove this unless specifically needed for custom dimensions/metrics
    };
  }


  // Creates a simple snapshot of item keys and quantities
  function getSnapshot(contents) {
    const snapshot = {};
     if (!Array.isArray(contents)) {
        console.error("getSnapshot received non-array:", contents);
        return snapshot;
    }
    contents.forEach(item => {
      // Ensure key exists and quantity is a valid number
      if (item && item.key !== undefined) {
         snapshot[item.key] = parseInt(item.quantity, 10) || 0;
      }
    });
    return snapshot;
  }

  // Fetches initial cart data on load
  function fetchCartData() {
    showLoading(); // Show loading on initial fetch
    $.ajax({
      type: "POST",
      url: $("#df-ajax-url").val(), // Ensure this element exists and has the URL
      data: { action: "get_cart_content" },
      success: function (response) {
        try {
          // Assuming response is a JSON string
          const cartData = response;
          // Dispatch event with the parsed data object
          document.dispatchEvent(new CustomEvent("cartDataLoaded", { detail: cartData }));
        } catch (e) {
           console.error("Error parsing initial cart data:", e, response);
           // Dispatch with empty data to potentially clear the cart view
           document.dispatchEvent(new CustomEvent("cartDataLoaded", { detail: { contents: [], total: 0 } }));
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
          console.error("Failed to fetch initial cart data:", textStatus, errorThrown);
          // Dispatch with empty data on error
          document.dispatchEvent(new CustomEvent("cartDataLoaded", { detail: { contents: [], total: 0 } }));
      },
      complete: function () {
          // Hide loading regardless of success/error after initial load attempt
          // Wait slightly to ensure updateCart has potentially run from success/error
          setTimeout(hideLoading, 100);
      }
    });
  }

  // --- Core Cart Update Logic ---
  function updateCart(data) {
    // Basic validation of incoming data
    if (!data || typeof data !== 'object' || !Array.isArray(data.contents)) {
      console.error("Invalid cart data received for update:", data);
      hideLoading(); // Ensure loading is hidden if update fails early
      return; // Prevent errors
    }

    const newContents = data.contents;
    const newTotal = parseFloat(data.total) || 0;
    const newKeys = new Set(newContents.map(item => item.key));

    // --- GTM Event Logic ---
    // Compare new state with the last snapshot for add/remove events
    // Only run comparisons if it's not the initial load
    if (!initialLoad) {
      // Check for added items or quantity increases
      newContents.forEach(newItem => {
        const itemKey = newItem.key;
        const oldQty = lastCartSnapshot[itemKey] || 0; // Quantity in previous state (0 if new)
        const newQty = parseInt(newItem.quantity, 10) || 0;
        const qtyDiff = newQty - oldQty;

        if (qtyDiff > 0) { // Item quantity increased OR item is entirely new
          const gtmItem = transformItemForGTM(newItem, qtyDiff); // Track the quantity *added*
          pushToDataLayer("add_to_cart", [gtmItem]); // Pass item(s) as an array
        }
      });

      // Check for quantity decreases (but not full removal, handled separately now)
      Object.keys(lastCartSnapshot).forEach(oldItemKey => {
         // Find the item in the new contents
         const correspondingNewItem = newContents.find(item => item.key === oldItemKey);
         const oldQty = lastCartSnapshot[oldItemKey] || 0;
         const newQty = correspondingNewItem ? (parseInt(correspondingNewItem.quantity, 10) || 0) : 0; // 0 if item disappeared

         if (newQty < oldQty) {
            // Item quantity decreased (or item removed - removal event handled by ajaxRequest success)
            const qtyDiff = oldQty - newQty; // Positive difference represents amount removed

            // We only push remove_from_cart due to QUANTITY CHANGE here.
            // Full removals triggered by the remove button are handled elsewhere.
            // Need the item details from *before* the change to report what was removed.
            const originalItemData = currentCart.contents.find(item => item.key === oldItemKey);

            if (originalItemData && qtyDiff > 0) {
                const gtmItem = transformItemForGTM(originalItemData, qtyDiff); // Track quantity *removed*
                pushToDataLayer("remove_from_cart", [gtmItem]); // Pass item(s) as an array
            }
         }
      });
    }
    // --- End GTM Event Logic ---


    // Update global cart state *after* comparisons
    currentCart = data;
    currentCartValue = newTotal;

    // --- DOM Update Logic ---

    // Remove items from UI that are no longer in the cart
    $("#offcanvas-cart-item-list [data-key]").each(function () {
      const itemKey = $(this).data("key");
      if (!newKeys.has(itemKey)) {
        $(this).remove();
      }
    });

    // Add new items or update existing items in the UI
    newContents.forEach((item) => {
      const $existing = $(`#offcanvas-cart-item-list [data-key='${item.key}']`);
      if ($existing.length) {
        // Update quantity for existing items
        const $qtyInput = $existing.find(".quantity");
        // Only update if value is different to avoid resetting cursor during typing
        if (parseInt($qtyInput.val(), 10) !== parseInt(item.quantity, 10)) {
            $qtyInput.val(item.quantity);
        }
         // Update previous value attribute as well
         $qtyInput.attr("data-previous-value", item.quantity);
        // Potentially update price too if it can change
        $existing.find(".offer").text(`$${parseFloat(item.offer).toLocaleString()}`);

      } else {
        // Add new item element to the UI
        addItem(item);
      }
    });

    // Update totals and visibility
    updateQuote(newTotal);
    toggleCartState();

    // Update the snapshot for the *next* comparison *after* all updates
    lastCartSnapshot = getSnapshot(newContents);

    hideLoading(); // Hide loading indicator after updates are done
  }


  // Pushes the view_cart event
  function pushViewCartEvent() {
     window.dataLayer = window.dataLayer || [];
     window.dataLayer.push({ ecommerce: null }); // Clear previous ecommerce object
     window.dataLayer.push({
       event: "view_cart",
       ecommerce: {
         currency: "USD", // Hardcoded, change if needed
         value: parseFloat(currentCartValue) || 0, // Ensure it's a number
         items: formatGTMData(currentCart.contents || []), // Format all items
       },
     });
     console.log("GTM Event: view_cart", { value: currentCartValue, items: formatGTMData(currentCart.contents || [])});
  }


  // Pushes add_to_cart or remove_from_cart events
  function pushToDataLayer(eventName, itemsArray) {
     // Ensure itemsArray is actually an array
    if (!Array.isArray(itemsArray) || itemsArray.length === 0) {
        console.warn(`GTM: ${eventName} event not pushed. No valid items provided.`);
        return;
    }

    // Calculate total value from the items being pushed *in this event*
    const eventValue = itemsArray.reduce((sum, item) => {
        // Ensure price and quantity are valid numbers for calculation
        const price = parseFloat(item.price) || 0;
        const quantity = parseInt(item.quantity, 10) || 0;
        return sum + (price * quantity);
    }, 0);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null }); // Clear previous ecommerce object
    window.dataLayer.push({
      event: eventName,
      ecommerce: {
        currency: "USD", // Hardcoded, change if needed
        value: parseFloat(eventValue.toFixed(2)), // Use calculated value for the event
        items: itemsArray, // Pass the already formatted items
      },
    });
    console.log(`GTM Event: ${eventName}`, { value: eventValue, items: itemsArray });
  }

  // Adds a new item element to the DOM
  function addItem(item) {
    // Ensure item data is valid
    if (!item || !item.key || !item.name) {
        console.error("Attempted to add invalid item to DOM:", item);
        return;
    }

    const sample = $("#offcanvas-cart-item-sample")?.clone()?.removeAttr("id")?.removeAttr("hidden");
    // Check if cloning worked
    if (!sample || sample.length === 0) {
        console.error("Failed to clone cart item sample. Does #offcanvas-cart-item-sample exist?");
        return;
    }

    sample.attr("data-key", item.key);
    sample.attr("data-category", item.category || "Other");
    sample.attr("data-subcategory", item.subcategory || "Other");

    // Safely access and update elements within the cloned sample
    sample.find(".offer").text(`$${(parseFloat(item.offer) || 0).toLocaleString()}`);
    sample.find(".quantity").val(parseInt(item.quantity, 10) || 1).attr("data-previous-value", parseInt(item.quantity, 10) || 1);
    sample.find(".item-title").text(item.name);

    // Handle image source, providing a fallback
    const imageUrl = item.image && item.image.trim() !== "" ? item.image : item.image_fb; // Assuming image_fb is a fallback
    sample.find(".image").attr({
      src: imageUrl || '', // Use fallback or empty string
      alt: item.name,
    }).removeAttr("style"); // Remove potential display:none styles

    // Handle attributes if they exist
    const attrWrap = sample.find("#attribute-wrapper");
    if (attrWrap.length > 0 && Array.isArray(item.attributes)) {
        const attrTemplate = sample.find("#item-attribute-template");
        if(attrTemplate.length > 0) {
             item.attributes.forEach(attr => {
                const attrItem = attrTemplate.clone().removeClass("hidden").removeAttr("id").text(attr);
                attrItem.appendTo(attrWrap);
            });
            attrTemplate.remove(); // Remove the template itself
        }
    } else {
        // If no attributes or wrapper, maybe remove the template placeholder
        sample.find("#item-attribute-template").remove();
    }

    sample.prependTo("#offcanvas-cart-item-list"); // Add to the top of the list
  }

  // Updates the total quote display
  function updateQuote(totalQuote) {
    const formatted = (Number(totalQuote) || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    $(".offer-number").text(`$${formatted}`);
    $(".offer-number-display").text(`$${formatted} offer`); // Update secondary display if exists
  }

  // Toggles the empty/full cart view states
  function toggleCartState() {
    // Check for list items excluding the sample template
    const hasItems = $("#offcanvas-cart-item-list > li:not(#offcanvas-cart-item-sample)").length > 0;
    // Use boolean argument for toggle for clarity
    $("#offer-list-wrapper, #checkout-action-wrapper").toggle(hasItems);
    $("#offer-list-empty").toggle(!hasItems);
  }

  // --- Server Interaction Functions ---

  // Calls the backend to update quantity
  function updateQuantity(key, quantity) {
    ajaxRequest("tradein_quantity_change", { key: key, quantity: quantity });
  }

  // Calls the backend to remove an item
  function removeItem(key) {
    // GTM event is handled by ajaxRequest success now
    ajaxRequest("product_remove", { key: key });
  }

  // Generic AJAX request handler
  function ajaxRequest(action, requestData) {
    if (ajaxActive) {
      console.warn("Ajax request blocked, another is active.");
      return; // Prevent concurrent requests
    }
    ajaxActive = true;
    // No need for showLoading() here, as callers handle it

    $.ajax({
      type: "post",
      url: $("#df-ajax-url").val(),
      data: {
        action: action, // e.g., 'product_remove', 'tradein_quantity_change'
        nonce: $("#df-ajax-nonce").val(), // Ensure this exists
        ...requestData, // e.g., { key: '...', quantity: '...' }
      },
      success: function (response) {
        let responseData = null;
        try {
            responseData = JSON.parse(response);
        } catch (e) {
            console.error(`Error parsing AJAX response for action ${action}:`, e, response);
             // Don't proceed with updateCart if parse fails
             return; // Exit success handler
        }

        // *** GTM Logic for Remove From Cart ***
        // If this AJAX call was specifically for removing an item AND we stored that item's data...
        if (action === 'product_remove' && itemPendingRemoval) {
          // Push the GTM event *using the stored data*
          pushToDataLayer("remove_from_cart", [itemPendingRemoval]);
          itemPendingRemoval = null; // Clear the temporary data
        }

        // Update the cart state and UI with the response from the server
        updateCart(responseData);

      },
      error: function (jqXHR, textStatus, errorThrown) {
          console.error(`AJAX Error for action ${action}:`, textStatus, errorThrown);
          // Maybe revert optimistic UI changes or show an error message
          // If it was a removal, clear pending item as it failed
          if (action === 'product_remove') {
              itemPendingRemoval = null;
          }
          // Re-fetch cart data to ensure consistency? Or show error.
          // fetchCartData(); // Be careful not to cause infinite loops on errors
          hideLoading(); // Hide loading on error
      },
      complete: function () {
        ajaxActive = false;
        // Ensure pending removal data is cleared even if success didn't run (e.g., parse error) or if error occurred
        itemPendingRemoval = null;
        // Don't hide loading here if success/error handles it, otherwise uncomment
        // hideLoading();
      },
    });
  }

})(jQuery);